import React from "react";
import { Badge, Tooltip } from "antd";
import ccIcon from "../../assets/images/icon-1-1.png";
import userIcon from "../../assets/images/icon-3-3.png";
import cfproIcon from "../../assets/images/icon-4-4.png";
import waitingIcon from "../../assets/images/icon-2-2.png";
import { useCount } from "../../context/liveContext.js";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const LiveCalls = () => {
  const {
    totalDeviceCCCount,
    totalDevice6Count,
    totalDeviceUserCount,
    waitingCount,
  } = useCount();

  const history = useHistory();
  const auth = useSelector((state) => state.auth.authenticated);
  const role_id = parseInt(auth.role, 10);
  const url = new URL(window.location.href);
  var pathSegments = url.pathname.split("/");
  var viewTenant = pathSegments[1];
  var tenantId = pathSegments[2];
  const key = `tenant_${tenantId}`;
  const selectedTenant = JSON.parse(localStorage.getItem(key));
  const tenantRoleId = parseInt(selectedTenant?.role, 10);


  const goToLiveStatus = (tabKey) => {
    if (role_id === 3) {
      history.push(`/voice/live-status?tab=${tabKey}`);
    } else if (viewTenant && tenantRoleId === 3 && tenantId) {
      history.push(`/view-tenant/${tenantId}/voice/live-status?tab=${tabKey}`);
    } else {
      history.push(`/live-status?tab=${tabKey}`);
    }
  };
  return (
    <div className="d-flex" style={{ justifyContent: "space-around" }}>
      <div className="d-flex ">
        <Tooltip placement="top" title="CC Calls">
          <img
            src={ccIcon}
            style={{ height: "20px" }}
            className="px-3 mt-2"
            alt="customer-service"
            onClick={() => goToLiveStatus("1")}
          />
        </Tooltip>
        <Badge
          className="tab-badge"
          style={{ background: "#000" }}
          count={totalDeviceCCCount}
        />
      </div>
      <div className="d-flex">
        <Tooltip placement="top" title="User Calls">
          <img
            src={userIcon}
            style={{ height: "20px" }}
            className="px-3 mt-2"
            alt="customer-service"
            onClick={() => goToLiveStatus("2")}
          />
        </Tooltip>
        <Badge
          className="tab-badge"
          style={{ background: "#000" }}
          count={totalDeviceUserCount}
        />
      </div>
      <div className="d-flex ">
        <Tooltip placement="top" title="CF Pro Calls">
          <img
            src={cfproIcon}
            style={{ height: "20px" }}
            className="px-3 mt-2"
            alt="customer-service"
            onClick={() => goToLiveStatus("3")}
          />
        </Tooltip>
        <Badge
          className="tab-badge"
          style={{ background: "#000" }}
          count={totalDevice6Count}
        />
      </div>
      <div className="d-flex ">
        <Tooltip placement="top" title="Waiting Calls">
          <img
            src={waitingIcon}
            className="px-3 mt-2"
            style={{ height: "20px" }}
            alt="customer-service"
            onClick={() => goToLiveStatus("1")}
          />
        </Tooltip>
        <Badge
          className="tab-badge"
          style={{ background: "#000" }}
          count={waitingCount}
        />
      </div>
    </div>
  );
};

export default LiveCalls;
